import React, { useState } from "react";
import { BadgeCheckIcon } from "lucide-react";
import { ReactionIcons } from "./ReactionIcons";
import type { FacebookComment } from "../../types/facebook";
type CommentItemProps = {
  comment: FacebookComment;
  isReply?: boolean;
};
export function CommentItem({
  comment,
  isReply = false
}: CommentItemProps) {
  const [liked, setLiked] = useState(false);
  const likes = comment.likes + (liked ? 1 : 0);
  const avatarSize = isReply ? "h-8 w-8" : "h-10 w-10";
  return <div className="flex gap-2" data-id="element-3" data-mp="ouggpyx0evtr">
      <Avatar comment={comment} className={avatarSize} data-id="element-4" data-mp="otf2xmolzv8c" />
      <div className="min-w-0 flex-1" data-id="element-5" data-mp="tu2ss513q60z">
        <div className="relative inline-block max-w-full rounded-2xl bg-fb-bg px-3 py-2" data-id="element-6" data-mp="tv4gpa37un04">
          <p className="flex items-center gap-1 text-[13px] font-semibold text-fb-text" data-id="element-7" data-mp="xud8wailyctk">
            {comment.author}
            {comment.isPage && <BadgeCheckIcon className="h-3.5 w-3.5 fill-fb-blue text-white" aria-label="Página verificada" data-id="element-8" data-mp="2vn95icpf546m" />}
            {comment.isPage && <span className="ml-1 text-xs font-normal text-fb-muted" data-id="element-9" data-mp="3t5zewn1nb5dy">· Autor</span>}
          </p>
          {comment.meta && <p className="text-xs text-fb-muted" data-id="element-10" data-mp="3oezhlgom6lax">{comment.meta}</p>}
          <p className="mt-0.5 text-[15px] leading-snug text-fb-text" data-id="element-11" data-mp="3odod1ench9ir">{comment.text}</p>
          {likes > 0 && <span className="absolute -bottom-2.5 right-1 flex items-center gap-1 rounded-full bg-white py-0.5 pl-0.5 pr-1.5 text-xs text-fb-muted shadow-[0_1px_3px_rgba(0,0,0,0.2)]" data-id="element-12" data-mp="3ehldmgjvnozi">
              <ReactionIcons types={comment.reactions} size="sm" data-id="element-13" data-mp="fxd4kfddw5zl" />
              {likes}
            </span>}
        </div>
        {comment.photo && <img src={comment.photo} alt={`Postre preparado por ${comment.author}`} className="mt-2 max-h-56 w-auto max-w-[240px] rounded-xl object-cover" loading="lazy" data-id="element-14" data-mp="608jkiv9ygkd" />}
        <div className="mt-1 flex items-center gap-3 px-3 text-xs font-bold text-fb-muted" data-id="element-15" data-mp="2qs0r5noim9lh">
          <span className="font-normal" data-id="element-16" data-mp="2lsefhioc51es">{comment.time}</span>
          <button type="button" onClick={() => setLiked(v => !v)} aria-pressed={liked} className={`transition-colors duration-150 hover:underline ${liked ? "text-fb-blue" : ""}`} data-id="element-17" data-mp="2lv0lhdvkv8uw">
            Me gusta
          </button>
          <span className="cursor-default" data-id="element-18" data-mp="13uszxaqnbhay">Responder</span>
        </div>

        {comment.replies && comment.replies.length > 0 && <div className="mt-3 space-y-3 border-l-2 border-fb-line/60 pl-3" data-id="element-19" data-mp="u5hsdsjeqkp6">
            {comment.replies.map(r => <CommentItem key={r.id} comment={r} isReply data-id="element-20" data-mp="yw7u8vsmk5f4" />)}
          </div>}
      </div>
    </div>;
}
function Avatar({
  comment,
  className
}: {
  comment: FacebookComment;
  className: string;
}) {
  if (comment.avatar) return <img src={comment.avatar} alt="" className={`${className} shrink-0 rounded-full object-cover`} data-id="element-21" data-mp="q3wattvxhi8n" />;
  const initials = comment.author.split(" ").map(p => p[0]).join("").slice(0, 2);
  return <span className={`${className} flex shrink-0 items-center justify-center rounded-full bg-gold text-sm font-bold text-white`} data-id="element-22" data-mp="g7b14v8yriyh">{initials}</span>;
}